<template>
  <component v-if="template" :is="template"/>
  <router-view v-else></router-view>
</template>

<script>
    import { SET_AUTHORIZED } from 'vx/mutations'
    import { mapMutations, mapGetters, mapState } from 'vuex'
    import AppChameleon from './templates/AppChameleon'
    import App from './templates/App'

    export default {

        mounted () {
        	var that = this;

            this.$bus.$on('userHasLoggTedOut', function () {
                that.destroyLogin()
            })

            this.$bus.$on('message', function(type, message) {
                $.notify(
                    {
                        message: message
                    },
                    {
                        type: type,
                        placement: {
                            from: "bottom",
                            align: "right"
                        },
                    }
                );
            })
        },
        created: function() {
        },

        data: function () {
            return {
                //user: null,
                token: null,
                authenticated: false
            }
        },

        methods: {
            ...mapMutations('user', [SET_AUTHORIZED]),

            destroyLogin: function (user) {
                // Cleanup when token was invalid our user has logged out
                this.user = null
                this.token = null
                this.authenticated = false
                localStorage.removeItem('token')
                if (this.$route.meta.auth) this.$route.router.push('/auth/login')
            }
        },

        computed: {
            ...mapState('user', ['authorized']),
            fullName: function() {
                return this.user.name;
            },

            template () {
              if (this.$route.meta.template) {
                switch (this.$route.meta.template) {
                  case 'chameleon':
                    return AppChameleon
                  default:
                    return App
                }
              }

              return false
            }
        }
    }
</script>
